<template>
  <div>
    <v-row align="stretch">
      <v-col md="9">
        <v-card class="px-8 py-4 fill-height" elevation="2">
          <div class="d-flex justify-space-between mb-3 align-center">
            <p class="mb-0">تیکت های ارسالی</p>
            <v-btn to="/ticket" color="primary">مشاهده همه</v-btn>
          </div>
          <v-data-table
            no-data-text="دیتایی وجود ندارد"
            :loading="ticketLoading"
            disable-sort
            :headers="ticketHeaders"
            :items="ticketList"
            :items-per-page="itemsPerPage"
            hide-default-footer
          >
            <template v-slot:[`item.departement`]="{ item }">
              <span v-if="item.departement === 'Py'">روانشناسی</span>
              <span v-else-if="item.departement === 'N'">تغذیه</span>
              <span v-else-if="item.departement === 'M'">پزشکی</span>
              <span v-else-if="item.departement === 'Ps'">روانپزشکی</span>
              <span v-else>پشتیبانی اپلیکیشن</span>
            </template>

            <template v-slot:[`item.date`]="{ item }">
              {{ item.date | moment("jYYYY/jMM/jDD") }}
            </template>
            <template v-slot:[`item.category`]="{ item }">
              <div class="text-center">
                <div v-if="item.category === 'H'">بالا</div>
                <div v-else-if="item.category === 'M'">متوسط</div>
                <div v-else>پایین</div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card class="px-8 py-4" elevation="2">
          <Doughnut
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
          />

          <div class="my-4 text-center primary--text">
            تعداد کل کاربران: {{ allUsers }}
          </div>
        </v-card>
      </v-col>

      <v-col>
        <v-card class="px-8 py-4" elevation="2">
          <div class="d-flex">
            <v-select
              v-model="userChartParams.step"
              item-text="name"
              item-value="value"
              clearable
              :items="timePeriod"
              outlined
              hide-details
              @change="getUserDataChart"
            ></v-select>

            <date-picker
              class="start-date-picker-input mr-3"
              display-format="jYYYY-jMM-jDD"
              locale="fa"
              format="YYYY-MM-DD"
              v-model="userChartParams.date_after"
              auto-submit
              placeholder="از تاریخ"
              @change="getUserDataChart"
            />

            <date-picker
              class="end-date-picker-input mr-3"
              display-format="jYYYY-jMM-jDD"
              locale="fa"
              format="YYYY-MM-DD"
              v-model="userChartParams.date_before"
              auto-submit
              placeholder="تا تاریخ"
              @change="getUserDataChart"
            />
          </div>

          <div class="my-4 text-center primary--text">
            <line-chart :chart-data="userChartData" />
          </div>
        </v-card>
      </v-col>

      <v-col >
        <v-card class="px-8 py-4" elevation="2">
          <div class="d-flex">
            <v-select
              v-model="financialChartParams.package"
              item-text="title"
              item-value="id"
              clearable
              :items="packages"
              outlined
              hide-details
              placeholder="انتخاب پکیج"
              @change="getFinancialDataChart"
            ></v-select>

            <v-select
            class="mr-3"
              v-model="financialChartParams.step"
              item-text="name"
              item-value="value"
              clearable
              :items="timePeriod"
              outlined
              hide-details
              @change="getFinancialDataChart"
            ></v-select>

            <date-picker
              class="start-date-picker-input mr-3"
              display-format="jYYYY-jMM-jDD"
              locale="fa"
              format="YYYY-MM-DD"
              v-model="financialChartParams.date_after"
              auto-submit
              placeholder="از تاریخ"
              @change="getFinancialDataChart"
            />

            <date-picker
              class="end-date-picker-input mr-3"
              display-format="jYYYY-jMM-jDD"
              locale="fa"
              format="YYYY-MM-DD"
              v-model="financialChartParams.date_before"
              auto-submit
              placeholder="تا تاریخ"
              @change="getFinancialDataChart"
            />
          </div>

          <div class="my-4 text-center primary--text">
            <line-chart :chart-data="financialChartData" />
          </div>
        </v-card>
      </v-col>

      <v-col md="6">
        <v-card class="px-8 py-4 fill-height" elevation="2">
          <div class="d-flex justify-space-between mb-3 align-center">
            <p class="mb-0">آخرین نظرات</p>
            <v-btn to="/foods-feedback" color="primary">مشاهده همه</v-btn>
          </div>
          <v-data-table
            no-data-text="دیتایی وجود ندارد"
            :loading="commentsLoading"
            disable-sort
            :headers="commentsHeaders"
            :items="commentsList"
            :items-per-page="itemsPerPage"
            hide-default-footer
          >
            <template v-slot:[`item.age`]="{ item }">
              {{ Number(item.age.toFixed(1)) }} ماه
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card class="px-8 py-4 fill-height" elevation="2">
          <div class="d-flex justify-space-between mb-3 align-center">
            <p class="mb-0">اخرین تراکنش‌ها</p>
            <v-btn to="/payment" color="primary">مشاهده همه</v-btn>
          </div>
          <v-data-table
            no-data-text="دیتایی وجود ندارد"
            :loading="paymentLoading"
            disable-sort
            :headers="paymentHeaders"
            :items="paymentList"
            :items-per-page="itemsPerPage"
            hide-default-footer
          >
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Doughnut } from "vue-chartjs/legacy";
import LineChart from "@/components/chart/lineChart";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";
import ticket from "@/Services/modules/ticket";
import foodComments from "@/Services/modules/foodComments";
import dashboard from "@/Services/modules/dashboard";
import payment from "@/Services/modules/payment";
import Package from "@/Services/modules/package"

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default {
  name: "DashboardPage",

  components: {
    Doughnut,
    LineChart,
  },
  props: {
    chartId: {
      type: String,
      default: "doughnut-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      allUsers: [],
      ticketList: [],
      commentsList: [],
      paymentList: [],

      ticketLoading: false,
      commentsLoading: false,
      paymentLoading: false,

      itemsPerPage: 4,
      ticketHeaders: [
        { text: "شناسه تیکت", value: "id" },
        { text: "نام", value: "first_name" },
        { text: "نام خانوادگی", value: "last_name" },
        { text: "شماره تماس", value: "phone_number" },
        { text: "دپارتمان", value: "departement" },
        { text: "تاریخ", value: "date" },
        { text: "اولویت", value: "category" },
      ],
      commentsHeaders: [
        { text: "نام", value: "first_name", width: "60px" },
        { text: "نام خانوادگی", value: "last_name", width: "100px" },
        { text: "شماره تماس", value: "phone_number" },
        { text: "سن", value: "age", width: "100px" },
        { text: "نام غذا", value: "food", width: "120px" },
        { text: "تاریخ", value: "create_at", width: "110px" },
      ],
      paymentHeaders: [
        { text: "نام محصول", value: "title", width: "100px" },
        { text: "کد پیگیری", value: "code" },
        { text: "نام", value: "first_name" },
        { text: "نام خانوادگی", value: "last_name" },
        { text: "شماره تماس", value: "phone_number" },
        { text: "قیمت", value: "price" },
        { text: "تاریخ", value: "date", width: "110px" },
      ],

      chartData: {
        labels: ["پسر", "دختر", "بدون فرزند"],
        datasets: [
          {
            backgroundColor: ["#3168d0", "#dc276b", "#329988"],
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },

      userChartData: {
        labels: [],
        datasets: [
          {
            label: "تعداد ثبت نام کاربران",
            backgroundColor: "#537DD7",
            data: [],
          },
        ],
      },
      financialChartData: {
        labels: [],
        datasets: [
          {
            label: "تعداد خریدهای روزانه",
            backgroundColor: "#537DD7",
            data: [],
          },
        ],
      },

      packages: [],
      userChartParams: {
        step: "month",
        date_after: null,
        date_before: null,
      },
      financialChartParams: {
        step: "month",
        package: null,
        date_after: null,
        date_before: null,
      },
      timePeriod: [
        { value: "day", name: "روزانه" },
        { value: "week", name: "هفتگی" },
        { value: "month", name: "ماهانه" },
        { value: "year", name: "سالانه" },
      ],
    };
  },

  mounted() {
    this.getPachageList()
    this.getPaymentList();
    this.getTicketData();
    this.getCommentsList();
    this.getChildCount();
    // chart
    this.getUserDataChart();
    this.getFinancialDataChart();
  },

  methods: {
    getPachageList() {
      Package.getAllPackage().then(res => {
        this.packages = res.data.results
      })
    },

    getFinancialDataChart() {
      dashboard.getFinancialChart(this.financialChartParams).then((res) => {
        this.financialChartData.datasets[0].data = res.data.total;
        this.financialChartData.labels = res.data.date;
      });
    },

    getUserDataChart() {
      dashboard.getUserChart(this.userChartParams).then((res) => {
        this.userChartData.datasets[0].data = res.data.total;
        this.userChartData.labels = res.data.date;
      });
    },

    getPaymentList() {
      this.paymentLoading = true;
      payment.getAllPayment().then((res) => {
        this.paymentList = res.data.results;
        this.paymentLoading = false;
      });
    },
    getChildCount() {
      dashboard.getChildCount().then((res) => {
        this.chartData.datasets[0].data.push(res.data.boys);
        this.chartData.datasets[0].data.push(res.data.girls);
        this.chartData.datasets[0].data.push(res.data.dont_have_child);
        this.allUsers = res.data.all;
      });
    },
    getCommentsList() {
      this.commentsLoading = true;
      foodComments.getAllComments().then((res) => {
        this.commentsList = res.data.results;
        this.commentsLoading = false;
      });
    },
    getTicketData() {
      this.ticketLoading = true;
      ticket.getTicketList().then((res) => {
        this.ticketList = res.data.results;
        this.ticketLoading = false;
      });
    },
  },
};
</script>
